import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import DetailItem from "../../../components/detailItem";
import { ActionTypes } from "../../../enums/actionTypes";
import swal from "sweetalert";
import activityTrailService from "../../../services/auditTrail/activityTrailService";
import mandateServiceTypeService from "../../../services/mandate/mandateServiceTypeService";
import { toast } from "react-toastify";
import { CummulativeDeductionConfig } from "../../../enums/recovaMandate/cummulativeDeductionConfig";
import { MandateDurationConfig } from "../../../enums/recovaMandate/mandateDuration";
import { PermissibleDeductionConfig } from "../../../enums/recovaMandate/permissibleDeductionConfig";
import { TransactionAmountSettings } from "../../../enums/recovaMandate/transactionAmountSettings";
import { getCurrentUsersRoles } from "../../../services/auth/authService";

interface IMandateServiceTypeDetailProps {
  showDetailsModal: boolean;
  toggleDetailsModal: any;
  toggleEditModal: any;
  showTrail: any;
  currentUserRoles: any;
  item: any;
}

interface IMandateServiceTypeDetailState {
  item: any;
  updatingStatus: boolean;
}

class MandateServiceTypeDetail extends Component<
  IMandateServiceTypeDetailProps,
  IMandateServiceTypeDetailState
> {
  state = {
    item: {},
    updatingStatus: false,
  };

  static getDerivedStateFromProps(
    nextProps: IMandateServiceTypeDetailProps,
    prevState
  ) {
    // console.log("current props: ", nextProps.item);
    return {
      item: nextProps.item,
    };
  }

  onHandleEnableOrDisable = (
    e: any,
    actionType: ActionTypes,
    entityName: string
  ) => {
    this.setState({ updatingStatus: true });
    if (!actionType) {
      this.handleEnableOrDisableItem(this.props.item);
    } else {
      swal({
        title: "Confirm!",
        text: `Are you sure you want to proceed to ${ActionTypes[actionType]} this ${entityName}?`,
        icon: "warning",
        buttons: {
          confirm: {
            text: "Yes",
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          cancel: {
            text: "Cancel",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          },
        },
        closeOnClickOutside: false,
        dangerMode: true,
      }).then((resp) => {
        if (resp) {
          // console.log("cancelling action...");
          this.setState({ updatingStatus: false });
        } else {
          this.handleEnableOrDisableItem(this.state.item);
        }
      });
    }
  };

  handleEnableOrDisableItem = async (_item: any) => {
    try {
      let approvalResponse: any = {};
      // this.setState({ updatingStatus: true });
      await activityTrailService.saveActivityTrail({
        actionType: `${_item.status === "Inactive" ? "Enable" : "Disable"
          } Mandate Service Type`,
        description: `Clicked on ${_item.status === "Inactive" ? "Enable" : "Disable"
          } to ${_item.status === "Inactive" ? "Enable" : "Disable"
          } Mandate Service Type ${_item.name}`,
      });
      switch (_item.status) {
        case "Inactive":
          approvalResponse = await mandateServiceTypeService.enableMandateServiceType(
            _item.id
          );
          if (approvalResponse.data.isLoggedForApproval === false) {
            _item.status = "Active";
          }
          break;
        case "Active":
          approvalResponse = await mandateServiceTypeService.disableMandateServiceType(
            _item.id
          );
          if (approvalResponse.data.isLoggedForApproval === false) {
            _item.status = "Inactive";
          }
          break;
        default:
          approvalResponse = await mandateServiceTypeService.enableMandateServiceType(
            _item.id
          );
          if (approvalResponse.data.isLoggedForApproval === false) {
            _item.status = "Active";
          }
          break;
      }
      if (approvalResponse.data.isLoggedForApproval === true) {
        toast.warn(approvalResponse.data.message, {
          autoClose: 6000,
          type: toast.TYPE.WARNING,
          position: "top-center",
          hideProgressBar: false,
        });
      } else {
        toast.info(
          `MandateServiceType ${_item.name} ${_item.status === "Active" ? "Enabled" : "Disabled"
          } successfully! `,
          {
            autoClose: 6000,
            type: toast.TYPE.DEFAULT,
            hideProgressBar: false,
          }
        );
      }
      this.setState({ updatingStatus: false, item: _item });
    } catch (ex) {
      this.setState({ updatingStatus: false, item: _item });
    }
  };

  render() {
    const {
      showDetailsModal,
      toggleDetailsModal,
      toggleEditModal,
      showTrail,
      currentUserRoles,
      item,
    } = this.props;
    const { updatingStatus } = this.state;
    return (
      <Modal
        size="xl"
        backdrop="static"
        show={showDetailsModal}
        onHide={toggleDetailsModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_.isEmpty(item) ? (
              <Skeleton width={500} />
            ) : (
              <h5>
                <i className="fab fa-first-order-alt fa-sm s-18 mr-3" />
                Mandate Service Type Details -{" "}
                <span className="font-weight-bold">{item.name}</span>
              </h5>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card">
            <div className="card-header clear-fix">
              {_.isEmpty(item) ? (
                <Skeleton width={200} />
              ) : (
                <h6
                  className="card-title float-left"
                  style={{ marginBottom: "0px" }}
                >
                  <b>General Information</b>
                </h6>
              )}
              <div className="float-right">
                {_.isEmpty(item) ? (
                  <Skeleton width={100} />
                ) : (
                  <span
                    className="badge btn-primary"
                    onClick={showTrail}
                    style={{
                      cursor: "pointer",
                      visibility: currentUserRoles.includes(
                        "viewaudittrailitems"
                      )
                        ? "visible"
                        : "hidden",
                    }}
                  >
                    View Trail
                  </span>
                )}
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={6} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Name"
                        labelSize={6}
                        valueSize={6}
                        value={item.name}
                      />
                      <DetailItem
                        label="Transaction Amount"
                        labelSize={6}
                        valueSize={6}
                        value={item.transactionAmount}
                      />
                      <DetailItem
                        label="Cumulative Deduction Count"
                        labelSize={6}
                        valueSize={6}
                        value={item.cumulativeDeductionCount}
                      />
                      <DetailItem
                        label="Mandate Duration"
                        labelSize={6}
                        valueSize={6}
                        value={item.mandateDuration}
                      />
                      <DetailItem
                        label="Permissible Deduction Count"
                        labelSize={6}
                        valueSize={6}
                        value={item.permissibleDeductionCount}
                      />
                      <DetailItem
                        label="Status"
                        labelSize={6}
                        valueSize={6}
                        value={
                          item.status === "Active" ? (
                            <span className="badge badge-success">
                              {item.status}
                            </span>
                          ) : (
                            <span className="badge badge-danger">
                              {item.status}
                            </span>
                          )
                        }
                      />
                    </dl>
                  )}
                </div>
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={6} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Description"
                        labelSize={6}
                        valueSize={6}
                        value={item.description}
                      />
                      <DetailItem
                        label="Transaction Amount Settings"
                        labelSize={6}
                        valueSize={6}
                        value={
                          item.transactionAmountCategory ===
                            TransactionAmountSettings[
                            TransactionAmountSettings.Fixed
                            ] ? (
                            <span className="badge badge-default">
                              {item.transactionAmountCategory}
                            </span>
                          ) : (
                            <span className="badge badge-warning">
                              {item.transactionAmountCategory}
                            </span>
                          )
                        }
                      />
                      <DetailItem
                        label="Cumulative Deduction Config"
                        labelSize={6}
                        valueSize={6}
                        value={
                          item.cumulativeDeductionConfig ===
                            CummulativeDeductionConfig[
                            CummulativeDeductionConfig.Fixed
                            ] ? (
                            <span className="badge badge-default">
                              {item.cumulativeDeductionConfig}
                            </span>
                          ) : (
                            <span className="badge badge-warning">
                              {item.cumulativeDeductionConfig}
                            </span>
                          )
                        }
                      />
                      <DetailItem
                        label="Mandate Duration Config"
                        labelSize={6}
                        valueSize={6}
                        value={
                          item.mandateDurationConfig ===
                            MandateDurationConfig[
                            MandateDurationConfig.Limited
                            ] ? (
                            <span className="badge badge-default">
                              {item.mandateDurationConfig}
                            </span>
                          ) : (
                            <span className="badge badge-warning">
                              {item.mandateDurationConfig}
                            </span>
                          )
                        }
                      />
                      <DetailItem
                        label="Permissible Deduction Config"
                        labelSize={6}
                        valueSize={6}
                        value={
                          item.permissibleDeductionConfig ===
                            PermissibleDeductionConfig[
                            PermissibleDeductionConfig.Limited
                            ] ? (
                            <span className="badge badge-default">
                              {item.permissibleDeductionConfig}
                            </span>
                          ) : (
                            <span className="badge badge-warning">
                              {item.permissibleDeductionConfig}
                            </span>
                          )
                        }
                      //value={item.permissibleDeductionConfig}
                      />
                    </dl>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {_.isEmpty(item) ? (
            <Skeleton width={100} count={2} height={30} />
          ) : (
            <React.Fragment>
              {item.status === "Inactive" &&
                getCurrentUsersRoles().includes(
                  "enablemandateservicetypes"
                ) && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={updatingStatus}
                    onClick={(e) =>
                      this.onHandleEnableOrDisable(
                        e,
                        item.status === "Inactive"
                          ? ActionTypes.ENABLE
                          : ActionTypes.DISABLE,
                        "Mandate Service Type"
                      )
                    }
                  >
                    <i className="far fa-edit mr-3" />
                    Enable
                  </Button>
                )}
              {item.status === "Active" &&
                getCurrentUsersRoles().includes(
                  "disablemandateservicetypes"
                ) && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={updatingStatus}
                    onClick={(e) =>
                      this.onHandleEnableOrDisable(
                        e,
                        item.status === "Inactive"
                          ? ActionTypes.ENABLE
                          : ActionTypes.DISABLE,
                        "Mandate Service Type"
                      )
                    }
                  >
                    <i className="far fa-edit mr-3" />
                    Disable
                  </Button>
                )}
              {getCurrentUsersRoles().includes("eidtmandateservicetypes") && (
                <Button
                  size="sm"
                  variant="primary"
                  disabled={updatingStatus}
                  onClick={toggleEditModal}
                >
                  <i className="far fa-edit mr-3" />
                  Edit
                </Button>
              )}
            </React.Fragment>
          )}
          <Button
            size="sm"
            variant="outline-danger"
            onClick={toggleDetailsModal}
          >
            <i className="fas fa-times mr-3" />
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default MandateServiceTypeDetail;
